import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=28f09e7c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=28f09e7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f09e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f09e7c')) {
      api.createRecord('28f09e7c', component.options)
    } else {
      api.reload('28f09e7c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=28f09e7c&scoped=true&", function () {
      api.rerender('28f09e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photoSelect/detail.vue"
export default component.exports